<script setup lang="ts">
import type { Url } from '@global-types/url.ts';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { computed } from 'vue';
import PlusMenuItem from '@layout/nav-v2/mobile/components/PlusMenuItem.vue';

interface PlusMenuLinkProps {
  link: Url,
  hasPin?: boolean,
}

const { link, hasPin = false } = defineProps<PlusMenuLinkProps>();

const { isCurrentPage } = useNavbarStore();

const isActive = computed<boolean>(() => isCurrentPage(link));
</script>

<template>
  <a
    :href="link"
    class="no-underline hover:bg-blue-lightest"
  >
    <PlusMenuItem
      :is-active="isActive"
      :has-pin="hasPin"
    >
      <template #icon>
        <slot name="icon" :is-active="isActive" />
      </template>

      <template #text>
        <slot name="text" />
      </template>
    </PlusMenuItem>
  </a>
</template>
